<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="sameWarehouseRelocation commonListStyles">
            <HeaderNav
                header-title="同仓移位"
                left-icon-name="2"
                right-icon-name="5"
                :extr="{ leftCallBack: swiperright, rightCallBack: addMovingInventory, iconName: 'sm-icon-test' }"
            ></HeaderNav>
            <section>
                <div class="queryCriteria">
                    <div class="queryItem queryTime" @click="selectDate">
                        <div class="queryTimeItem">
                            <van-icon name="notes-o"></van-icon>
                            <span>{{ startTimeValue }}</span>
                        </div>
                        <p>—</p>
                        <div class="queryTimeItem">
                            <van-icon name="notes-o"></van-icon>
                            <span>{{ endTimeValue }}</span>
                        </div>
                    </div>
                </div>
                <van-search v-model="keyVal" placeholder="请输入搜索信息" @change="onRefresh"></van-search>
                <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                    <van-list
                        v-model="isUpLoading"
                        finished-text="没有更多了!"
                        :finished="finished"
                        @load="onLoad"
                    >
                        <ul class="list">
                            <li class="listItem" v-for="(item,index) in listData" :key="`item_${index}`">
                                <div class="engineeringInfo" @click="openMovingInventory(item)">
                                    <h4 class="itemTitle">
                                        <span class="iconfont iconhetong">移库单编号：{{ item.MoveNo }}</span>
                                    </h4>
                                    <div class="itemContent">
                                        <p>
                                            <img src="@/assets/images/icons/icon_47@2x.png" alt="">
                                            <span>仓库名称：{{ item.StockName }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_5@2x.png" alt="">
                                            <span>原库位名称：{{ item.OldGridName }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_46@2x.png" alt="">
                                            <span>物料代码：{{ item.MaterialCode }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_28@2x.png" alt="">
                                            <span>物料短描述：{{ item.MaterialShortName }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_5@2x.png" alt="">
                                            <span>新库位名称：{{ item.NewGridName }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_38@2x.png" alt="">
                                            <span>移库库存：{{ item.MoveVolume }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_8@2x.png" alt="">
                                            <span>操作人：{{ item.CreatorName }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_7@2x.png" alt="">
                                            <span>移库时间：{{ item.MoveTime }}</span>
                                        </p>
                                    </div>
                                    <div class="itemBtn">
                                        <button>查看</button>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </van-list>
                </van-pull-refresh>
            </section>
            <van-calendar
                type="range"
                v-model="showCalendar"
                :min-date="minDate"
                :default-date="defaultDate"
                @confirm="confirmSelectDate"
            ></van-calendar>
        </div>
    </v-touch>
</template>

<script>
import currencyFun from '@/assets/js/currencyFun/index.js';
import { mixin_list } from '@/assets/mixin/mixin_list';
export default {
    name: 'same-warehouse-relocation',
    mixins: [mixin_list],
    beforeRouteLeave(to, from, next) {
        if (to.path === '/home') {
            this.$store.commit('noKeepAlive', 'same-warehouse-relocation');
        }
        next();
    },
    data() {
        return {
            startTimeValue: '',
            endTimeValue: '',
            showCalendar: false,
            defaultDate: [],
            minDate: new Date(2000, 0, 1),
            requestUrl: '/procurement/material_move_grid/page_list',
            initIndex: 1,
            pageIndex: 1,
            indexKey: 'PageIndex',
            sizeKey: 'PageSize',
        };
    },
    filters: {},
    computed: {},
    watch: {},
    activated() {
        if (this.$route.params.saveCallback) {
            this.onRefresh();
        }
    },
    created() {
        const dates = currencyFun.getMonthData();
        this.startTimeValue = dates.startDate;
        this.endTimeValue = dates.endDate;
    },
    mounted() {},
    methods: {
        loadRequestData() {
            return {
                MoveTimeMin: this.startTimeValue,
                MoveTimeMax: this.endTimeValue,
                [this.indexKey]: this.pageIndex,
                [this.sizeKey]: this.pageSize,
                SearchKey: this.keyVal,
            };
        },

        selectDate() {
            this.defaultDate = [new Date(this.startTimeValue), new Date(this.endTimeValue)];
            this.showCalendar = true;
        },

        confirmSelectDate(val) {
            this.startTimeValue = currencyFun.timeFormat(new Date(val[0]), 'yyyy-MM-dd');
            this.endTimeValue = currencyFun.timeFormat(new Date(val[1]), 'yyyy-MM-dd');
            this.showCalendar = false;
            this.onRefresh();
        },

        addMovingInventory() {
            this.$router.isBack = 2;
            this.$router.push({ name: 'movingInventoryForm', params: { type: 'new' } });
        },

        openMovingInventory(item) {
            this.$router.isBack = 2;
            this.$router.push({ name: 'movingInventoryForm', params: { type: 'maintain', data: item } });
        },
    },
};
</script>
<style lang="stylus">
.sameWarehouseRelocation
    .van-pull-refresh
        height: calc(100% - 90rpx) !important
</style>
